import {
  Flex,
  useIsUserAuth,
  useStickySafeNavigate,
} from '@equifinance/shared';
import styled from 'styled-components';
import { useEffect } from 'react';
import Page from '../Page';
import ManageDetailsSection from './ManageDetailsSection';

const SubHeadContainer = styled(Flex)`${({ theme }) => `
  justify-content: space-between;
  gap: ${theme.padding[2]};
  align-items: center;
  height: ${theme.collapseHeaderHeight};
  padding: 0 ${theme.padding[8]};
  background: ${theme.colours.neutral[9]};
  box-shadow: ${theme.boxShadow[2]};
`}`;

const Navigator = styled.p`${({ theme }) => `
  font-family: 'Montserrat';
  color: ${theme.colours.neutral[4]};
  font-size: ${theme.fontSize[1]};
  font-weight: ${theme.fontWeight.bold};
  cursor: pointer;
`}`;

const Container = styled.div`
  width:100%;
`;

export default function BrokerUserPage() {
  const navigate = useStickySafeNavigate();
  const isExternalUser = useIsUserAuth();

  useEffect(() => {
    if (!isExternalUser) {
      navigate('/403');
    }
  }, []);

  return (
    <Page
      subHeader={(
        <SubHeadContainer>
          <Navigator onClick={() => navigate('/')}>
            Home
          </Navigator>
        </SubHeadContainer>
      )}
    >
      <Container>
        <ManageDetailsSection />
      </Container>
    </Page>
  );
}
